(function () {
  function getCurrentLanguage() {
    var htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    var path = window.location.pathname.toLowerCase();

    if (htmlLang.indexOf('en') === 0 || path.indexOf('/en') === 0) {
      return 'en';
    }

    if (htmlLang.indexOf('it') === 0 || path.indexOf('/it') === 0) {
      return 'it';
    }

    return 'it';
  }

  var currentLanguage = getCurrentLanguage();

  var translationsByLanguage = {
    en: {
      'Selezione del Re': 'The King’s Selection',
      'Selezione del re': 'The King’s Selection',
      'Nuovi Arrivi': 'New Arrivals',
      'Nuovi arrivi': 'New Arrivals',
      'Borsa da viaggio': 'Travel Bag',
      'Borse da viaggio': 'Travel Bags',
      'Pugnale Reale': 'Roya Digger',
      'Acconsento al trattamento dei dati forniti in questo modulo per finalità di marketing.': 'I consent to the processing of the data provided in this form for marketing purposes.'
    },

    it: {
      'I agree with the terms and conditions': 'Accetto i termini e le condizioni di vendita',
      'I agree with the Terms and Conditions': 'Accetto i termini e le condizioni di vendita',
      'I agree to the terms and conditions': 'Accetto i termini e le condizioni di vendita',
      'I accept the terms and conditions': 'Accetto i termini e le condizioni di vendita'
    }
  };

  var translations = translationsByLanguage[currentLanguage] || {};

  function replaceTextNode(node) {
    if (!node || node.nodeType !== 3) return;

    var originalText = node.nodeValue;
    var newText = originalText;

    for (var original in translations) {
      if (Object.prototype.hasOwnProperty.call(translations, original)) {
        newText = newText.split(original).join(translations[original]);
      }
    }

    if (newText !== originalText) {
      node.nodeValue = newText;
    }
  }

  function scanText(root) {
    if (!root) return;

    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    var node;

    while ((node = walker.nextNode())) {
      var parent = node.parentNode;
      if (!parent || !parent.tagName) continue;

      var tag = parent.tagName.toLowerCase();

      if (
        tag === 'script' ||
        tag === 'style' ||
        tag === 'noscript' ||
        tag === 'textarea'
      ) {
        continue;
      }

      replaceTextNode(node);
    }
  }

  function fixContactCheckboxes() {
    if (currentLanguage !== 'en') return;

    var privacyInput = document.querySelector('input[name="contact[privacy_consent]"]');
    var marketingInput = document.querySelector('input[name="contact[marketing_consent]"]');

    if (privacyInput) {
      var privacyLabel = privacyInput.closest('label');
      var privacySpan = privacyLabel ? privacyLabel.querySelector('span') : null;

      if (privacySpan && privacySpan.getAttribute('data-manual-translated') !== 'true') {
        privacySpan.innerHTML =
          'I consent to the processing of the data provided in this form (required field). ' +
          'For more information, please see the ' +
          '<a href="/en/pages/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.';

        privacySpan.setAttribute('data-manual-translated', 'true');
      }

      privacyInput.setAttribute('value', 'Yes');
    }

    if (marketingInput) {
      var marketingLabel = marketingInput.closest('label');
      var marketingSpan = marketingLabel ? marketingLabel.querySelector('span') : null;

      if (marketingSpan && marketingSpan.getAttribute('data-manual-translated') !== 'true') {
        marketingSpan.textContent =
          'I consent to the processing of the data provided in this form for marketing purposes.';

        marketingSpan.setAttribute('data-manual-translated', 'true');
      }

      marketingInput.setAttribute('value', 'Yes');
    }
  }

  function fixCartTermsCheckbox() {
    if (currentLanguage !== 'it') return;

    var cartTermsLabel = document.querySelector('label[for="CartDrawer-Form_agree"]');

    if (
      cartTermsLabel &&
      cartTermsLabel.getAttribute('data-manual-translated') !== 'true'
    ) {
      cartTermsLabel.innerHTML =
        'Accetto i ' +
        '<a href="/pages/terms-conditions" title="Termini e condizioni">' +
        '<strong>termini e condizioni di vendita</strong>' +
        '</a>';

      cartTermsLabel.setAttribute('data-manual-translated', 'true');
    }
  }

  function runManualTranslations() {
    scanText(document.body);
    fixContactCheckboxes();
    fixCartTermsCheckbox();
  }

  function runSeveralTimes() {
    runManualTranslations();

    setTimeout(runManualTranslations, 300);
    setTimeout(runManualTranslations, 1000);
    setTimeout(runManualTranslations, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runSeveralTimes);
  } else {
    runSeveralTimes();
  }
})();